'use client';

export { ContactForm } from '@/components/forms/ContactForm';
